import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { newContact } from '../../actions/contact';

const AddContact = ({ newContact, history }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    organization: '',
    job: '',
    phone: '',
    email: '',
    url: '',
    location: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    status: '',
    tag: '',
    leadSource: '',
    background: ''
  });

  const {
    firstName,
    lastName,
    job,
    organization,
    phone,
    email,
    url,
    location,
    city,
    state,
    zip,
    country,
    status,
    tag,
    leadSource,
    background
  } = formData;

  const onChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    newContact(formData, history);
  };

  return (
    <div className='text-center'>
      <h1>Add Contact</h1>
      <form className='form' onSubmit={e => onSubmit(e)}>
        <div className='form-group'>
          <input
            type='text'
            placeholder='First Name'
            name='firstName'
            value={firstName}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='Last Name'
            name='lastName'
            value={lastName}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='Job Title'
            name='job'
            value={job}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='Organization'
            name='organization'
            value={organization}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='number'
            placeholder='Mobile Number'
            name='phone'
            value={phone}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='email'
            placeholder='Email'
            name='email'
            value={email}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='URL'
            name='url'
            value={url}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='Address'
            name='location'
            value={location}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='City'
            name='city'
            value={city}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='State'
            name='state'
            value={state}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='number'
            placeholder='Zip'
            name='zip'
            value={zip}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='Country'
            name='country'
            value={country}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <select name='status' value={status} onChange={e => onChange(e)}>
            <option value='0'>Status</option>
            <option value='Lead'>Lead</option>
            <option value='Prospect'>Prospect</option>
            <option value='Trail'>Trail</option>
            <option value='Customer'>Customer</option>
            <option value='Inactive'>Inactive</option>
            <option value='General'>General</option>
            <option value='Partner'>Partner</option>
          </select>
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='Tags'
            name='tag'
            value={tag}
            onChange={e => onChange(e)}
          />
        </div>
        <div className='form-group'>
          <select
            name='leadSource'
            value={leadSource}
            onChange={e => onChange(e)}
          >
            <option value='0'>Select (Optional)</option>
            <option value='Advertisement'>Advertisement</option>
            <option value='EmailOrWeb'>Email or Web</option>
            <option value='Generation'>List Generation</option>
            <option value='Partner'>Partner</option>
            <option value='Affiliate'>Affiliate</option>
            <option value='Seminar'>Seminar</option>
            <option value='Social'>Social</option>
            <option value='Tradeshow'>Tradeshow</option>
            <option value='Word'>Word of Mouth</option>
            <option value='Other'>Other</option>
          </select>
        </div>
        <div className='form-group'>
          <input
            type='text'
            placeholder='Background'
            name='background'
            value={background}
            onChange={e => onChange(e)}
          />
        </div>
        <input type='submit' className='btn btn-firm' value='Save' />
      </form>
    </div>
  );
};

AddContact.propTypes = {
  newContact: PropTypes.func.isRequired
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, { newContact })(AddContact);



// WEBPACK FOOTER //
// ./src/components/contact/AddContact.js